export default {
	EMPTY_VALUE: '-',
};
